import React, { useEffect, useRef, useState } from 'react';
import FreeCamToggle from './FreeCamToggle';
import MuteToggle from './MuteToggle';
// Icone de la charte (meme fichier que 2/public/brand/), recopiee dans
// static/brand/ pour que webpack la serve avec le reste des assets.
// @ts-ignore
import brandIcon from '../../../../static/brand/icone-couleur.svg';

interface InfoOverlayProps {
    visible: boolean;
}

const NAME_TEXT = 'FORASTECH';
const TITLE_TEXT = 'Consultant en Informatique';
const MULTIPLIER = 1;

const InfoOverlay: React.FC<InfoOverlayProps> = ({ visible }) => {
    const visRef = useRef(visible);
    const [nameText, setNameText] = useState('');
    const [titleText, setTitleText] = useState('');
    const [textDone, setTextDone] = useState(false);
    const [volumeVisible, setVolumeVisible] = useState(false);
    const [freeCamVisible, setFreeCamVisible] = useState(false);

    const typeText = (
        i: number,
        curText: string,
        text: string,
        setText: React.Dispatch<React.SetStateAction<string>>,
        callback: () => void,
        refOverride?: React.MutableRefObject<string>
    ) => {
        if (refOverride) {
            text = refOverride.current;
        }
        if (i < text.length) {
            setTimeout(() => {
                if (visRef.current === true)
                    window.postMessage(
                        { type: 'keydown', key: `_AUTO_${text[i]}` },
                        '*'
                    );

                setText(curText + text[i]);
                typeText(
                    i + 1,
                    curText + text[i],
                    text,
                    setText,
                    callback,
                    refOverride
                );
            }, Math.random() * 50 + 50 * MULTIPLIER);
        } else {
            callback();
        }
    };

    useEffect(() => {
        if (visible && nameText === '') {
            setTimeout(() => {
                typeText(0, '', NAME_TEXT, setNameText, () => {
                    typeText(0, '', TITLE_TEXT, setTitleText, () => {
                        setTextDone(true);
                    });
                });
            }, 400);
        }
        visRef.current = visible;
    }, [visible]);

    useEffect(() => {
        if (textDone) {
            setTimeout(() => {
                setVolumeVisible(true);
                setTimeout(() => {
                    setFreeCamVisible(true);
                }, 250);
            }, 250);
        }
    }, [textDone]);

    useEffect(() => {
        window.postMessage({ type: 'keydown', key: `_AUTO_` }, '*');
    }, [freeCamVisible, volumeVisible]);

    return (
        <div style={styles.wrapper}>
            {(visible || nameText !== '') && (
                <div style={styles.infoBox}>
                    <img
                        src={brandIcon}
                        alt="ForAsTech"
                        style={styles.logo}
                        draggable={false}
                    />
                    <div style={styles.textColumn}>
                        <p style={styles.nameText}>{nameText}</p>
                        <p style={styles.titleText}>{titleText}</p>
                    </div>
                </div>
            )}

            {textDone && (
                <div style={styles.lastRow}>
                    {volumeVisible && (
                        <div style={styles.lastRowChild}>
                            <MuteToggle />
                        </div>
                    )}
                    {freeCamVisible && (
                        <div style={styles.lastRowChild}>
                            <FreeCamToggle />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    wrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: 16,
    },
    infoBox: {
        // Etait backgroundColor 'white' AVEC color 'white' : le texte etait
        // bien la, mais invisible. Le fond passe au navy de la charte, ou le
        // blanc ressort — et la scene a un fond de studio clair, donc une
        // boite sombre se detache nettement mieux.
        backgroundColor: '#0a1730',
        color: '#ffffff',
        padding: '16px 14px',
        borderRadius: 12,
        borderLeft: '3px solid #12c2b0',
        boxShadow: '0 8px 28px rgba(10, 23, 48, 0.35)',
        width: 'fit-content',
        maxWidth: '100%',
        alignSelf: 'flex-start',
        // Ligne logo + texte : le libelle garde sa pile nom/fonction a droite
        // de l'icone, comme sur le logotype complet.
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    logo: {
        width: 40,
        height: 40,
        flexShrink: 0,
        display: 'block',
        userSelect: 'none',
    },
    textColumn: {
        display: 'flex',
        flexDirection: 'column',
        // Hauteur stable pendant que le texte se tape caractere par
        // caractere, sinon la boite sautille a chaque ligne qui apparait.
        minHeight: 40,
        justifyContent: 'center',
    },
    nameText: {
        // Couleur posee ici et non heritee : la regle globale sur <p>
        // l'emporterait sinon, et le libelle redeviendrait illisible.
        margin: 0,
        fontSize: 24,
        // Syne 700, la police des titres du site.
        fontFamily: "'Syne UI', 'Montserrat UI', ui-sans-serif, sans-serif",
        fontWeight: 700,
        color: '#ffffff',
        letterSpacing: '0.01em',
    },
    titleText: {
        margin: 0,
        fontSize: 18,
        marginTop: 4,
        color: '#d7dde6',
        // Syne 700 ici aussi : la ligne de fonction doit suivre le nom, et la
        // regle globale sur <p> imposerait Montserrat 600 sans ca.
        fontFamily: "'Syne UI', 'Montserrat UI', ui-sans-serif, sans-serif",
        fontWeight: 700,
        letterSpacing: '0.01em',
    },
    lastRow: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 8,
        marginLeft: 8,
    },
    lastRowChild: {
        marginRight: 8,
    },
};

export default InfoOverlay;
